<template>
  <div>
    {{ lot }} xxx
  </div>
</template>
<script>
  export default {
    data: function() {
      return {
      }
    },
    props: ['lot', 'auction'],
    methods: {
    },
    mounted() {
    },
    computed: {
    }
  }
</script>
